import { useMutation, useQueryClient } from '@tanstack/react-query';
import { custodianService, CustodianFormData } from '@/services/custodian/custodian-service';
import { custodianKeys } from '@/services/query-keys/custodian-keys';

interface UpdateCustodianVariables {
  id: number;
  data: CustodianFormData;
  // LR-468: whether account_number changed vs the seeded value — drives whether
  // it is sent in the PATCH (an unchanged value is omitted to skip the blocking
  // Backoffice lookup).
  accountNumberChanged: boolean;
}

export const useUpdateCustodian = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data, accountNumberChanged }: UpdateCustodianVariables) =>
      custodianService.updateCustodian(id, data, { accountNumberChanged }),
    onSuccess: () => {
      // Invalidates the register list AND the trade-entry dropdown (shared
      // `['custodians']` prefix).
      queryClient.invalidateQueries({ queryKey: custodianKeys.all });
    },
  });
};
